import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum WithdrawalFormErrorStatesEnum {
    RegisterBankWithdrawalFailed = ErrorStateScheduleEnum.WithdrawalFormStatesStartIndex,
    RegisterInternalWithdrawalFailed,
    CanFindCorrectPaymentMethod
}
